import { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import {
  useGetFerpaStatusMutation,
  useShowIdentificationFieldsMutation
} from '../../features/authentication/assignApiSlice';
import {
  selectFerpaState,
  setFerpaState
} from '../../features/authentication/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';

const FERPA = forwardRef(({ hideCheckBox }, ref) => {
  const [getFerpaStatus] = useGetFerpaStatusMutation();
  const [showIdentificationFields] = useShowIdentificationFieldsMutation();
  const ferpaState = useSelector(selectFerpaState);
  const [ferpaEnabled, setFerpaEnabled] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();

  useImperativeHandle(ref, () => ({
    getPopupState() { return showPopup },
    setPopupState(state) { setShowPopup(state) },
    setFerpaState(state) { handleFerpaChange(state) }
  }));

  useEffect(() => {
    fetchFerpaStatus();
  }, []);

  useEffect(() => {
    setFerpaEnabled(ferpaState);
  }, [ferpaState]);

  const fetchFerpaStatus = async () => {
    const response = await getFerpaStatus().unwrap();
    setFerpaEnabled(response.showIdentificationFields);
    dispatch(setFerpaState({
      ferpaEnabled: response.showIdentificationFields
    }));
  };

  const handleFerpaChange = async (newState) => {
    setFerpaEnabled(newState);
    dispatch(
      setFerpaState({
        ferpaEnabled: newState
      })
    );

    const data = {
      condition: newState
    };
    try {
      await showIdentificationFields(data).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className='ferpaContainer'>
      <div
        className="d-flex flex-row align-items-center cursor-pointer"
        onClick={() => setShowPopup(!showPopup)}>
        <FontAwesomeIcon
          icon={faCircleInfo}
          className='mr-1 fs-5 clr-castleRed'
        />
        <div className='ferpa'>FERPA</div>
      </div>

      {showPopup && <div className="d-flex flex-row ferpaMessage text-start">
        <div className="d-flex flex-column">
          <p>
            Student identification information should not be printed or displayed publicly
            or emailed as per FERPA requirements.
          </p>
          <a
            href="https://www2.ed.gov/policy/gen/guid/fpco/ferpa/index.html"
            target="_blank"
            rel="noreferrer"
            className="link-orange mb-3"
          >
            Family Educational Rights and Privacy Act (FERPA)
          </a>
          {!hideCheckBox && <Form.Check
            type="checkbox"
            id="displayStudentNames"
            className="d-flex flex-row align-items-center">
            <Form.Check.Input
              type="checkbox"
              checked={ferpaEnabled}
              className='mr-1'
              onClick={() => handleFerpaChange(!ferpaEnabled)}
            />
            <Form.Check.Label>Display Student Names/Identification</Form.Check.Label>
          </Form.Check>}
        </div>
        <FontAwesomeIcon
          className='fs-5 cursor-pointer clr-castleRed'
          icon={faX}
          onClick={() => setShowPopup(false)}
        />
      </div>}
    </div>
  );
});


FERPA.propTypes = {
  hideCheckBox: PropTypes.bool
};
export default FERPA;